import { render, staticRenderFns } from "./BabyCompare.vue?vue&type=template&id=c66aefca&"
import script from "./BabyCompare.vue?vue&type=script&lang=js&"
export * from "./BabyCompare.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports